import { Button } from "antd";
import styled from "styled-components";

const StyledButton = styled(Button)`
  height: 40px;
`;

export default StyledButton;
